import $ from 'jquery';
import config from './config';

let dropdowns = [];

export default class TownshipInfo {

    // initialize this on page load.
    static intialize(lateLoading) {

        lateLoading(true);
        let agencyId = JSON.parse(sessionStorage.getItem('token')).id;
        dropdowns.push({
            key: 0,
            value: 0,
            label: 'Not Selected',
            isSelected: false  
        });

        $.ajax({
            type: 'GET',
            url: `${config.server}/gettownships/${agencyId}`,
            contentType: 'application/json',
            success: (data) => {
                console.log('gettownships', data)
                data.map((item) => {
                    dropdowns.push({
                        key: item.Id,
                        value: item.Id,
                        label: item.TownshipName,
                        unOrganized: item.UnOrganized,
                        isSelected: false
                    });
                });
                lateLoading(false);
            },
        });

    }


    static getTownshipDropdowns() {
        return dropdowns;
    }

}





// WEBPACK FOOTER //
// ./src/TownshipInfo.js